(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5067],{

/***/ 93209:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/london/seo-audit-london",
      function () {
        return __webpack_require__(55242);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 55242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ seo_audit_london; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/animation.ts
var animation = __webpack_require__(89428);
// EXTERNAL MODULE: ./src/components/reuseable/links/NextLink.tsx
var links_NextLink = __webpack_require__(99472);
// EXTERNAL MODULE: ./src/components/blocks/hero/index.ts + 35 modules
var hero = __webpack_require__(46978);
// EXTERNAL MODULE: ./src/components/blocks/process/index.ts + 28 modules
var process = __webpack_require__(15508);
// EXTERNAL MODULE: ./src/data/process.ts + 1 modules
var data_process = __webpack_require__(79870);
// EXTERNAL MODULE: ./src/components/reuseable/ContactFooterCombo.tsx
var ContactFooterCombo = __webpack_require__(79266);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
;// CONCATENATED MODULE: ./src/components/blocks/call-to-action/CTA1.tsx


var CTA1 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper ",
        children: /*#__PURE__*/ _jsx("div", {
            className: "container pb-16 pb-md-18",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row gx-lg-8 gx-xl-12 gy-10 mb-8 align-items-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-lg-7 order-lg-2",
                        children: /*#__PURE__*/ _jsx("figure", {
                            children: /*#__PURE__*/ _jsx(Image, {
                                layout: "responsive",
                                alt: "analyze now",
                                className: "w-auto",
                                width: 640,
                                height: 458,
                                src: "/img/illustrations/i3.png"
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-lg-5",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "fs-16 text-uppercase text-muted mb-3",
                                children: "Analyze Now"
                            }),
                            /*#__PURE__*/ _jsx("h3", {
                                className: "display-4 mb-5",
                                children: "Wonder how much faster your website can go? Easily check your SEO Score now."
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "mb-7",
                                children: "Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Praesent commodo cursus magna, vel scelerisque nisl consectetur et."
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "row",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "col-lg-9",
                                    children: /*#__PURE__*/ _jsx("form", {
                                        action: "#",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "form-floating input-group",
                                            children: [
                                                /*#__PURE__*/ _jsx("input", {
                                                    type: "url",
                                                    className: "form-control",
                                                    placeholder: "Enter Website URL",
                                                    id: "seo-check"
                                                }),
                                                /*#__PURE__*/ _jsx("label", {
                                                    htmlFor: "seo-check",
                                                    children: "Enter Website URL"
                                                }),
                                                /*#__PURE__*/ _jsx("button", {
                                                    className: "btn btn-primary",
                                                    type: "button",
                                                    children: "Check"
                                                }),
                                                " "
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var call_to_action_CTA1 = ((/* unused pure expression or super */ null && (CTA1)));

;// CONCATENATED MODULE: ./src/components/blocks/call-to-action/CTA2.tsx


var CTA2 = function() {
    return /*#__PURE__*/ _jsx("section", {
        style: {
            backgroundImage: "url(/img/map.png)"
        },
        className: "wrapper image-wrapper bg-auto no-overlay bg-image text-center bg-map",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container pt-0 pb-14 pt-md-18 pb-md-18",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "row",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "col-lg-10 col-xl-9 col-xxl-8 mx-auto",
                        children: /*#__PURE__*/ _jsx("h3", {
                            className: "display-4 mb-8 px-lg-12",
                            children: "We are trusted by over 5000+ clients. Join them now and grow your business."
                        })
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex justify-content-center",
                    children: [
                        /*#__PURE__*/ _jsx(NextLink, {
                            href: "#",
                            title: "Get Started",
                            className: "btn btn-primary rounded mx-1"
                        }),
                        /*#__PURE__*/ _jsx(NextLink, {
                            href: "#",
                            title: "Free Trial",
                            className: "btn btn-green rounded mx-1"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var call_to_action_CTA2 = ((/* unused pure expression or super */ null && (CTA2)));

;// CONCATENATED MODULE: ./src/components/blocks/call-to-action/CTA3.tsx

var CTA3 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper image-wrapper bg-auto no-overlay bg-image text-center mb-14 mb-md-16 bg-map",
        style: {
            backgroundImage: "url(/img/map.png)"
        },
        children: /*#__PURE__*/ _jsx("div", {
            className: "container py-md-18",
            children: /*#__PURE__*/ _jsx("div", {
                className: "row",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "col-lg-6 col-xl-5 mx-auto",
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: "display-4 mb-3 text-center",
                            children: "Join Our Community"
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "lead mb-5 px-md-16 px-lg-3",
                            children: "We are trusted by over 5000+ clients. Join them by using our services and grow your business."
                        }),
                        /*#__PURE__*/ _jsx("a", {
                            href: "#",
                            className: "btn btn-primary rounded-pill",
                            children: "Join Us"
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var call_to_action_CTA3 = ((/* unused pure expression or super */ null && (CTA3)));

// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
;// CONCATENATED MODULE: ./src/components/blocks/call-to-action/CTA4.tsx


var CTA4 = function(param) {
    var title = param.title, body = param.body, buttonTitle = param.buttonTitle, buttonLink = param.buttonLink;
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper image-wrapper bg-image bg-overlay mt-0",
        style: {
            backgroundImage: "url(/img/photos/bg1.jpg)"
        },
        children: /*#__PURE__*/ _jsx("div", {
            className: "container py-18",
            children: /*#__PURE__*/ _jsx("div", {
                className: "row",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "col-lg-8",
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: "fs-16 text-uppercase text-white mb-3 text-line",
                            children: title
                        }),
                        /*#__PURE__*/ _jsx("h3", {
                            className: "display-4 mb-5 mb-6 text-white pe-xxl-18",
                            children: body
                        }),
                        /*#__PURE__*/ _jsx(ScrollLink, {
                            activeClass: "active",
                            to: "contact",
                            spy: true,
                            smooth: true,
                            offset: 0,
                            duration: 500,
                            className: "btn btn-white rounded mb-0 text-nowrap",
                            children: "Get in touch"
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var call_to_action_CTA4 = ((/* unused pure expression or super */ null && (CTA4)));

;// CONCATENATED MODULE: ./src/icons/lineal/Puzzle.tsx

var Puzzle = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 507.4 512",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-md mb-4"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M257.9 15.2v65.1c-28.7-15.6-64.7-5-80.3 23.8s-5 64.7 23.8 80.3c17.6 9.6 38.9 9.6 56.6 0v65.1h59.9c-8.4-31.6 10.5-64 42.1-72.4 31.6-8.4 64 10.5 72.4 42.1 2.6 9.9 2.6 20.4 0 30.3h59.9V70.7c0-30.7-24.9-55.5-55.5-55.5H257.9z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M436.7 0h-366C31.7 0 0 31.7 0 70.7v370.6c0 39 31.7 70.7 70.7 70.7h188.1c8.4 0 15.2-6.8 15.2-15.1V453c5.5 1 11.2 1.3 16.8 1 17.5-.9 34.2-7.9 47.1-19.9 30.1-28 31.7-75.1 3.7-105.2-23.2-24.8-60.2-30.8-90-14.6-7.3 4-10.1 13.2-6.1 20.6 4 7.4 13.2 10.1 20.6 6.1 7.4-4 15.7-5.8 24.1-5.2 24.3 1.7 42.6 22.8 40.9 47-1.5 21.8-19.8 39.8-41.7 40.8-8.1.4-16.1-1.4-23.2-5.3-2.2-1.2-4.7-1.8-7.3-1.8-8.4 0-15.2 6.8-15.2 15.2v49.9h-173c-22.3 0-40.3-18.1-40.3-40.3V264.6h28.7c-.5 2.6-.8 5.2-1 7.8-2.9 41 28 76.6 69 79.5 1.8.1 3.6.2 5.3.2 18.8.1 37-7.1 50.7-20 24.8-23.2 30.8-60.1 14.6-89.9-.1-.2-.2-.3-.3-.5-4.1-7.3-13.4-9.9-20.7-5.7-7.3 4.1-9.9 13.4-5.7 20.7 4 7.4 5.8 15.8 5.2 24.2-1.7 24.3-22.8 42.5-47.1 40.8-21.8-1.5-39.8-19.8-40.8-41.7-.4-8.1 1.4-16.1 5.2-23.3 1.2-2.2 1.9-4.7 1.9-7.3 0-8.4-6.8-15.2-15.2-15.2H30.4V70.7c0-22.3 18.1-40.3 40.3-40.3h172v28.7c-8.7-1.6-17.6-1.6-26.2 0-40.5 7.2-67.4 45.9-60.1 86.4s45.9 67.4 86.4 60.1v43.9c0 8.4 6.8 15.2 15.2 15.2h59.9c1.6 0 3.2-.3 4.7-.7 8-2.6 12.3-11.2 9.7-19.2-.6-2.5-1-5.1-1.2-7.7-1.5-24.3 16.9-45.2 41.2-46.7.9-.1 1.8-.1 2.7-.1 3.8 0 7.6.5 11.3 1.5 23.5 6.2 37.5 30.4 31.3 53.9-.3 1.3-.5 2.6-.5 3.9 0 8.4 6.8 15.2 15.2 15.2h59.9c8.4 0 15.2-6.8 15.2-15.2V70.7c-.1-39-31.7-70.7-70.7-70.7zM477 234.2h-27.5c0-41.1-33.3-74.4-74.4-74.4-1.5 0-3 0-4.6.1-36 2.2-65.9 30.9-69.5 66.8-.2 2.5-.4 5-.4 7.5h-27.5v-49.9c0-2.5-.6-5-1.8-7.3-4-7.4-13.2-10.1-20.6-6.1-7.4 4-15.7 5.8-24.1 5.2-24.3-1.7-42.6-22.8-40.9-47 1.5-21.8 19.8-39.8 41.7-40.8 8.1-.4 16.1 1.4 23.2 5.3 2.2 1.2 4.7 1.8 7.3 1.8 8.4 0 15.2-6.8 15.2-15.2V30.4h163.6c22.3 0 40.3 18.1 40.3 40.3v163.5z"
            })
        ]
    });
};
/* harmony default export */ var lineal_Puzzle = (Puzzle);

;// CONCATENATED MODULE: ./src/components/blocks/call-to-action/CTA5.tsx


var CTA5 = function(param) {
    var body = param.body;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "wrapper bg-soft-primary",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container py-14 py-md-16 text-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-md-9 col-lg-7 col-xl-7 mx-auto text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(lineal_Puzzle, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "display-4 mb-3",
                                children: "Get a quote"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "lead fs-lg mb-6 px-xl-10 px-xxl-15",
                                children: body
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-6 col-lg-5 col-xl-4 mx-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "newsletter-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "mc_embed_signup2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                    name: "quote",
                                    method: "post",
                                    "data-netlify": "true",
                                    action: "/",
                                    target: "_blank",
                                    className: "validate",
                                    id: "mc-embedded-subscribe-form2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "hidden",
                                            name: "form-name",
                                            value: "quote"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "messages"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            id: "mc_embed_signup_scroll2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mc-field-group input-group form-floating",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            required: true,
                                                            type: "email",
                                                            name: "EMAIL",
                                                            id: "mce-EMAIL2",
                                                            autoComplete: "off",
                                                            placeholder: "email address",
                                                            className: "required email form-control"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            htmlFor: "mce-EMAIL2",
                                                            className: "text-start",
                                                            children: "Email Address"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "valid-feedback",
                                                            children: " Looks good! "
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "invalid-feedback",
                                                            children: " Please enter your first name. "
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "submit",
                                                            value: "Quote ",
                                                            name: "subscribe",
                                                            id: "mc-embedded-subscribe2",
                                                            className: "btn btn-primary"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    id: "mce-responses2",
                                                    className: "clear",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "response",
                                                            id: "mce-error-response2",
                                                            style: {
                                                                display: "none"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "response",
                                                            id: "mce-success-response2",
                                                            style: {
                                                                display: "none"
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    "aria-hidden": "true",
                                                    style: {
                                                        position: "absolute",
                                                        left: "-5000px"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        name: "b_ddc180777a163e0f9f66ee014_4b1bcfa0bc",
                                                        tabIndex: -1
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "clear"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var call_to_action_CTA5 = (CTA5);

;// CONCATENATED MODULE: ./src/components/blocks/call-to-action/CTA6.tsx

var CTA6 = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "wrapper image-wrapper bg-auto no-overlay bg-image text-center bg-map",
        style: {
            backgroundImage: "url(/img/map.png)"
        },
        children: /*#__PURE__*/ _jsx("div", {
            className: "container py-md-16 py-lg-18",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl-11 col-xxl-9 mx-auto",
                        children: /*#__PURE__*/ _jsx("h3", {
                            className: "display-4 mb-8 px-lg-8",
                            children: "We are trusted by over 5000+ clients. Join them now and grow your business."
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "d-flex justify-content-center",
                        children: /*#__PURE__*/ _jsx("span", {
                            children: /*#__PURE__*/ _jsx("a", {
                                className: "btn btn-primary rounded-pill",
                                children: "Get Started"
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var call_to_action_CTA6 = ((/* unused pure expression or super */ null && (CTA6)));

;// CONCATENATED MODULE: ./src/components/blocks/call-to-action/CTA7.tsx

var CTA7 = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "container-card",
        children: /*#__PURE__*/ _jsx("div", {
            className: "card image-wrapper bg-full bg-image bg-overlay bg-overlay-light-500 mb-14",
            style: {
                backgroundImage: "url(/img/photos/bg22.png)"
            },
            children: /*#__PURE__*/ _jsx("div", {
                className: "card-body py-14 px-0",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "row text-center",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "col-xl-11 col-xxl-9 mx-auto",
                                children: [
                                    /*#__PURE__*/ _jsx("h2", {
                                        className: "fs-16 text-uppercase text-gradient gradient-1 mb-3",
                                        children: "Join Our Community"
                                    }),
                                    /*#__PURE__*/ _jsx("h3", {
                                        className: "display-4 mb-7 px-lg-17",
                                        children: "We are trusted by over 5000+ clients. Join them now and grow your business."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "d-flex justify-content-center",
                            children: /*#__PURE__*/ _jsx("span", {
                                children: /*#__PURE__*/ _jsx("a", {
                                    className: "btn btn-lg btn-gradient gradient-1 rounded",
                                    children: "Get Started"
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var call_to_action_CTA7 = ((/* unused pure expression or super */ null && (CTA7)));

;// CONCATENATED MODULE: ./src/components/blocks/call-to-action/CTA8.tsx

var CTA8 = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "container",
        children: /*#__PURE__*/ _jsx("div", {
            className: "card image-wrapper bg-full bg-image bg-overlay bg-overlay-300 mb-14",
            style: {
                backgroundImage: "url(/img/photos/bg16.png)"
            },
            children: /*#__PURE__*/ _jsxs("div", {
                className: "card-body p-10 p-xl-12",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "row text-center",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "col-xl-11 col-xxl-9 mx-auto",
                            children: [
                                /*#__PURE__*/ _jsx("h2", {
                                    className: "fs-16 text-uppercase text-white mb-3",
                                    children: "Join Our Community"
                                }),
                                /*#__PURE__*/ _jsxs("h3", {
                                    className: "display-3 mb-8 px-lg-8 text-white",
                                    children: [
                                        "We are ",
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "underline-3 style-2 yellow",
                                            children: "trusted"
                                        }),
                                        " by over 5000+ clients. Join them now and grow your business."
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "d-flex justify-content-center",
                        children: /*#__PURE__*/ _jsx("span", {
                            children: /*#__PURE__*/ _jsx("a", {
                                className: "btn btn-white rounded",
                                children: "Get Started"
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var call_to_action_CTA8 = ((/* unused pure expression or super */ null && (CTA8)));

;// CONCATENATED MODULE: ./src/components/blocks/call-to-action/CTA9.tsx


var CTA9 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper image-wrapper bg-image bg-overlay text-white",
        style: {
            backgroundImage: "url(/img/photos/bg33.jpg)"
        },
        children: /*#__PURE__*/ _jsx("div", {
            className: "container py-14 py-md-17 text-center",
            children: /*#__PURE__*/ _jsx("div", {
                className: "row",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "col-xl-10 col-xxl-8 mx-auto text-center",
                    children: [
                        /*#__PURE__*/ _jsx("i", {
                            className: "icn-flower text-white fs-30 opacity-50"
                        }),
                        /*#__PURE__*/ _jsx("h2", {
                            className: "display-4 text-white mt-2 mb-7",
                            children: "I'm here to capture your moments. Looking for a caring, fun, passionate photographer?"
                        }),
                        /*#__PURE__*/ _jsx(NextLink, {
                            title: "Contact Me",
                            href: "#",
                            className: "btn btn-white rounded-pill mb-5"
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var call_to_action_CTA9 = ((/* unused pure expression or super */ null && (CTA9)));

;// CONCATENATED MODULE: ./src/components/blocks/call-to-action/CTA10.tsx

var CTA10 = function() {
    return /*#__PURE__*/ _jsxs("section", {
        className: "wrapper bg-soft-primary",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "container py-14 py-md-16",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "row mb-8",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "col-lg-8 mx-auto text-center",
                            children: [
                                /*#__PURE__*/ _jsx("h2", {
                                    className: "fs-16 text-uppercase text-primary mb-3",
                                    children: "Analyze Now"
                                }),
                                /*#__PURE__*/ _jsx("h3", {
                                    className: "display-4 mb-0",
                                    children: "Wonder how much faster your website can go? Easily check your SEO Score now."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "row",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "col-lg-5 mx-auto",
                            children: /*#__PURE__*/ _jsx("form", {
                                action: "#",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "form-floating input-group",
                                    children: [
                                        /*#__PURE__*/ _jsx("input", {
                                            type: "url",
                                            className: "form-control border-0",
                                            placeholder: "Enter Website URL",
                                            id: "analyze"
                                        }),
                                        /*#__PURE__*/ _jsx("label", {
                                            htmlFor: "analyze",
                                            children: "Enter Website URL"
                                        }),
                                        /*#__PURE__*/ _jsx("button", {
                                            className: "btn btn-primary",
                                            type: "button",
                                            children: "Analyze"
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("figure", {
                children: /*#__PURE__*/ _jsx("img", {
                    src: "/img/photos/clouds.png",
                    alt: ""
                })
            })
        ]
    });
};
/* harmony default export */ var call_to_action_CTA10 = ((/* unused pure expression or super */ null && (CTA10)));

;// CONCATENATED MODULE: ./src/components/blocks/call-to-action/index.ts












// EXTERNAL MODULE: ./src/components/blocks/services/index.ts + 33 modules
var services = __webpack_require__(90587);
// EXTERNAL MODULE: ./src/data/service.ts + 16 modules
var service = __webpack_require__(69864);
// EXTERNAL MODULE: ./src/components/blocks/video/Video.tsx
var Video = __webpack_require__(62920);
// EXTERNAL MODULE: ./src/components/common/SEO.tsx
var SEO = __webpack_require__(2034);
// EXTERNAL MODULE: ./src/data/keywords.ts
var keywords = __webpack_require__(74870);
;// CONCATENATED MODULE: ./src/data/all-pages-dynamic-content/london/seo-audit/how-long-does-an-seo-audit-take.js
var howlongdoesanseoaudittake = [
    {
        body: "How long does an SEO audit take?",
        url: ""
    },
    {
        body: "There is no standard time frame for an SEO audit because every website is different. Each audit is specifically designed to meet the requirements of the targeted website. The time and effort required for an SEO audit can vary, though.",
        url: ""
    },
    {
        body: "The size of the website should be the primary concern. The auditing process may take more time if the website is very large or contains numerous pages or material. Another factor is the site's intricacy. A website with fewer pages and fewer levels and parts will be simpler to analyse.",
        url: ""
    },
    {
        body: "The nature of the audit itself is a secondary consideration. An exhaustive audit may take more time than a superficial one because its investigation of factors like keyword optimisation, content quality, link development, etc. is more in-depth. ",
        url: ""
    },
    {
        body: "One further thing to think about is how knowledgeable the auditor is. A professional with more expertise conducting audits will likely do them more quickly than someone with less experience or who is unfamiliar with SEO methods and techniques. As a result of the synergy of knowledge and effort, audits that involve numerous persons (such as a team or group) may be completed more quickly. ",
        url: ""
    },
    {
        body: "As a last point, an SEO audit's duration can be impacted by any technical issues with the website. Broken links and slow-loading sites can increase the length of an audit because they must be fixed before any optimisation for search engine rankings can be implemented. ",
        url: ""
    },
    {
        body: "The length of time it takes to do an SEO audit depends on a number of factors, and knowing them will help you plan your SEO approach more effectively. You can ensure that your SEO approach will help your website realise its full potential over time by giving careful thought to each of the aforementioned elements, including site size/complexity, audit type, and audit personnel expertise.",
        url: ""
    }, 
];
/* harmony default export */ var how_long_does_an_seo_audit_take = (howlongdoesanseoaudittake);

;// CONCATENATED MODULE: ./src/data/all-pages-dynamic-content/london/seo-audit/how-to-do-technical-seo-audit.js
var howtodotechnicalseoaudit = [
    {
        body: "What is Technical SEO?",
        url: ""
    },
    {
        body: "Technical SEO is the practice of optimizing a website for search engine crawlers, with the aim of improving overall website visibility. Technical SEO involves examining your website's architecture, page structure, content delivery networks, and server configurations to ensure that search engines can properly crawl and index your website. Technical SEO also involves optimizing page titles, meta descriptions, URL structures, tag optimization, image alt tags and other elements that may impact a website’s ranking in search engine results pages (SERPs).",
        url: ""
    },
    {
        body: "Why Perform a Technical SEO Audit?",
        url: ""
    },
    {
        body: "A technical SEO audit is an essential step in optimizing a website's performance in search engine results pages (SERPs). Without one, it would be impossible to identify and fix any technical issues that could be holding back your website from achieving its full potential. A technical SEO audit can help you identify problems such as broken links or missing images that could be preventing search engine robots from properly crawling your site. Additionally, an audit can provide valuable insights into how well your website is structured for optimal performance in SERPs.",
        url: ""
    },
    {
        body: "How to Perform a Technical SEO Audit",
        url: ""
    },
    {
        body: "1. Identify Page Indexation Issues: The first step in performing a technical SEO audit is to determine whether or not all of the pages of your site have been properly indexed by the major search engines. To do this, use webmaster tools such as Google Search Console or Bing Webmaster Tools to check if all pages are being properly indexed by each platform. If any pages are not indexed, investigate why this might be and make appropriate changes to ensure they are being indexed correctly. ",
        url: ""
    },
    {
        body: "2. Review Your Site's Architecture: Your site's architecture should be organized in such a way that it makes it easy for search engine robots to crawl and index pages efficiently. Ensure that your URLs are formatted logically using only lowercase letters and hyphens instead of underscores; avoid using too many parameters or having too many folders deep within the structure of the site; and use descriptive URLs which accurately describe the content found on each page. ",
        url: ""
    },
    {
        body: "3. Optimize Your Page Titles: Page titles are one of the most important elements when it comes to optimizing for SERPs as they tell users what information will be found on each page when they click through from the results page. Make sure that all page titles are unique and descriptive so users know exactly what information will be found on each page when they click through from SERPs. ",
        url: ""
    },
    {
        body: "4. Optimize Meta Descriptions: Meta descriptions are short summaries which appear beneath each listing in SERPs and give users more information about what can be found on each page when they click through from the results page. Make sure all meta descriptions are unique and accurately describe what can be found on each page so users know exactly what information they will find when they arrive at your site after clicking through from SERPS. ",
        url: ""
    },
    {
        body: "5. Check Image Alt Tags: Image Alt Tags help search engines understand what images contain so that they can accurately index them for relevant keywords searches; however if these tags are missing or incorrectly formatted then search engines may not get an accurate understanding of what an image contains which could negatively impact its ability to rank for relevant queries. Check all images on your site have valid Alt Tags formatted correctly with only lowercase letters using hyphens instead of underscores",
        url: ""
    },
    {
        body: "6. Check Internal Link Structure: Internal links provide signals to search engines about which pages on your site are important and should receive higher rankings in SERP results pages; however if these links are not set up correctly then this signal may not reach search engines correctly which could result in lower rankings or even no rankings at all for certain queries related to those particular pages.. Ensure all internal links point directly to their destination page with no redirects involved; use only lowercase letters with hyphens instead of underscores; avoid using too many parameters or having too many folders deep within the link structure; use descriptive anchor text which accurately describes link destination; and make sure all internal links point towards valid pages with no 404 errors involved.. ",
        url: ""
    },
    {
        body: "7. Review Server Configuration Settings: Finally review server configuration settings such as caching headers, file compression settings, redirects, canonicalization rules etc., ensuring all settings are configured correctly so that visitors receive an optimal experience regardless of device type or connection speed used when accessing your website.. Additionally investigate any crawl errors reported by webmaster tools like Google Search Console or Bing Webmaster Tools as these may indicate issues with how robots access certain parts of your site which should be fixed as soon as possible.. ",
        url: ""
    },
    {
        body: "Performing regular technical SEO audits is essential if you want to optimize the performance of your website in SERPs and ensure visitors receive an optimal experience regardless of device type used or connection speed available when accessing your site.. Identify any indexation issues using webmaster tools like Google Search Console or Bing Webmaster Tools; review architecture structure ensuring URLs use only lowercase letters with hyphens instead of underscores; optimize page titles making sure they accurately describe content found on each page; optimize meta descriptions providing users with more information regarding content found on each page after clicking through from SERPS; check image alt tags ensuring they accurately describe contents within images; review internal link structure making sure anchor text accurately describes link destination;;and finally check server configuration settings ensuring everything is configured correctly so visitors receive an optimal experience regardless of device type used or connection speed available when accessing your site.. By following these steps you can ensure your website is properly optimized for search engine crawlers and can achieve its full potential in SERPs.",
        url: ""
    }, 
];
/* harmony default export */ var how_to_do_technical_seo_audit = (howtodotechnicalseoaudit);

;// CONCATENATED MODULE: ./pages/london/seo-audit-london/index.tsx




// -------- custom component -------- //












var details = {
    pageName: "SEO Audit London | Seo Audit Services",
    categories: "seo, web design",
    description: "Moltoprovides seo audit services to greatly improve your site ranking. Get your free technical SEO audit now from Molto SEO audit London",
    parentDirectories: ""
};
var seoAuditPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: "".concat(keywords.SEOAudit[0].title),
                description: details.description,
                tag: details.categories,
                urlPT: "",
                urlENPT: "",
                url: "".concat(keywords.SEOAudit[0].url, "/").concat(keywords.SEOAudit[0].title.toLowerCase().replace(/ /g, "-")),
                image: "img/".concat(keywords.HomeList[0].title.toLowerCase().replace(/ /g, "-"), ".jpg")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                        className: "content-wrapper bg-white",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: (0,animation/* fadeInAnimate */.St)("900ms"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Video["default"], {
                                    heading: keywords.SEOAudit[0].title,
                                    title1: "SEO",
                                    title2: "AUDIT",
                                    title3: "",
                                    movie: "/1.mp4",
                                    placeholder: "1-bg.jpg",
                                    button: "website-test",
                                    fontsize1: 150,
                                    fontsize2: 150,
                                    body: "",
                                    intro: " helps London companies improve Google ranking with our free SEO audit. If\xa0you\xa0want to accelerate your business online, we are the experts using proprietary technology and AI."
                                })
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "website-test-intro"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(hero/* Hero1 */.lE, {
                                bgcolor: "bg-soft-primary mb-20",
                                title: "",
                                lead: "",
                                body: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-center",
                                        id: "report",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-center fs-34 mb-0 mx-auto",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                    children: [
                                                        "GET YOUR FREE ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-fuchsia",
                                                            children: "TECHNICAL SEO REPORT"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-center fs-18 mx-auto",
                                                children: [
                                                    "Action the findings from the report or purchase ",
                                                    keywords.HomeList[8].title
                                                ]
                                            })
                                        ]
                                    }, 100)
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "ai-seo"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "wrapper bg-dark angled wrapper angled upper-end mt-20 mb-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "container pb-5 pt-md-10 mb-md-10 text-light items-bg-light",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(process/* Process1 */.G, {
                                        title: "",
                                        subtitle: keywords.SEOAudit[4].title,
                                        body: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "lead text-light",
                                                children: "An SEO audit is an in-depth analysis of how well a website is optimised for search engines. It analyses how well a website performs in terms of search engine optimisation and suggests changes to be made. Finding out how your website is doing in terms of search engine optimisation and where there may be room for improvement is made much easier with the help of an SEO audit service."
                                            }, "100"),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "lead text-light",
                                                children: "As the world becomes more digital, the way people search for information and products is constantly evolving. That's why we keep our client websites responsive to changes in how people search.  People change in the way they search - they're asking natural questions too. The future of search is creating new opportunities for you to promote your business very effectively."
                                            }, "101"),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "lead text-light",
                                                children: [
                                                    "In addition to looking at the website's present standing in the search engine results pages, the",
                                                    keywords.SEOAudit[4].title,
                                                    " will also look at the competition and do keyword research. By doing so, we can pinpoint any optimisation opportunities that could boost our exposure and position in search engine results pages. In addition to identifying areas for improvement, the audit will suggest best practises and optimisations that can be used to boost the site's overall performance."
                                                ]
                                            }, "102")
                                        ],
                                        list: data_process/* seoAuditList1 */.f2,
                                        buttonLink: "/#contact",
                                        buttonTitle: "Get in touch",
                                        displayButton: "d-none",
                                        src: "",
                                        alt: keywords.SEOAudit[0].title
                                    })
                                })
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "wrapper bg-white",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "container",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "row",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-md-12",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                    children: [
                                                        keywords.SEOAudit[0].title,
                                                        ": ",
                                                        how_long_does_an_seo_audit_take[0].body
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "col-md-6",
                                                    children: [
                                                        how_long_does_an_seo_audit_take.slice(1, how_long_does_an_seo_audit_take.length).map(function(item, index) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "row",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "col-md-12",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "lead",
                                                                            children: item.body
                                                                        })
                                                                    })
                                                                })
                                                            }, index);
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                children: "Molto SEO"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-md-6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/img/".concat(keywords.SEOAudit[0].title.toLowerCase().replace(/ /g, "-"), ".jpg"),
                                                        alt: keywords.SEOAudit[0].title,
                                                        className: "img-fluid",
                                                        style: {
                                                            maxWidth: "100%"
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(services/* Services19 */.hi, {
                                title: keywords.HomeList[9].title,
                                serviceList: service/* serviceList9 */.lf
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "wrapper bg-white mt-15",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "container",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "row",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-md-7 mx-auto",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        children: keywords.SEOAudit[5].title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        children: how_to_do_technical_seo_audit[2].body
                                                    })
                                                ]
                                            })
                                        }),
                                        how_to_do_technical_seo_audit.slice(3, 4).map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "row",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "col-md-7 mx-auto",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "lead",
                                                                children: item.body
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                className: "mw mt-5 mb-15",
                                                                src: "/img/" + keywords.SEOAudit[3].title.toLowerCase().replace(/ /g, "-") + ".png",
                                                                alt: keywords.SEOAudit[3].title
                                                            })
                                                        ]
                                                    })
                                                })
                                            }, index);
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "wrapper bg-white pb-17",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "container",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "row",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-md-7 mx-auto",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        children: keywords.SEOAudit[8].title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        children: how_to_do_technical_seo_audit[4].body
                                                    })
                                                ]
                                            })
                                        }),
                                        how_to_do_technical_seo_audit.slice(5, how_to_do_technical_seo_audit.length).map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "row",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "col-md-7 mx-auto",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "lead",
                                                            children: item.body
                                                        })
                                                    })
                                                })
                                            }, index);
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(call_to_action_CTA5, {
                                body: "Join our happy clients with our ".concat(keywords.HomeList[8].title, " to grow your business.")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "wrapper bg-white pb-17",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col-md-7 mx-auto",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    children: keywords.SEOAudit[2].title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "Here at Molto SEO, our number one priority is to offer you the finest ",
                                                        keywords.SEOAudit[2].title,
                                                        " ",
                                                        "available. Our SEO audit is a thorough evaluation of your site's existing optimisation levels."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: keywords.SEOAudit[3].title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "If you want more traffic to your ecommerce website, a higher search engine rating, and your site to run more smoothly, you need to do an ",
                                                        keywords.SEOAudit[3].title,
                                                        ". An SEO audit is a comprehensive analysis of your website's performance in search engines like Google. Our staff can assist you in making these changes and optimising your content for search engines by detecting these aspects."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Here at Molto SEO, we take into account both on-page and off-page SEO criteria when conducting an audit of your site. Our audit consists of a thorough examination of the following factors:"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: "Organisation and Mapping of a Website"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "We check your site's architecture and menus to guarantee they're straightforward and simple to use. We also look for technical problems that could be slowing down your site's performance and fix them if we find any."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: "Keyword Research"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "We examine your website's keyword usage extensively to identify successful and underperforming terms. You'll learn how to outrank the competition by doing keyword research on their sites and finding gaps in their online presence."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/img/".concat(keywords.SEOAudit[1].title.toLowerCase().replace(/ /g, "-"), ".png"),
                                                    alt: keywords.SEOAudit[1].title,
                                                    className: "mw mt-5 mb-13"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: "Examining the Content"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "We check your website's content for search engine optimisation and user interest to better serve you. We also look for problems like broken links, missing pages, and duplicate material that could be slowing down your site."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: "Domain Authority"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "We examine the profile of inbound links to your website to ascertain their quality and number. We also investigate the possibility that low-quality or spammy links have been placed on your site."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: "Social Media"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "We take a look at your social media profiles to see if they are helping or hindering your search engine optimisation. We also give you tips on how to make your social media efforts more in line with your SEO objectives."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "After performing an SEO audit, we will deliver a comprehensive report that details our findings and suggestions for enhancing your website's search engine optimisation. We'll help you put these suggestions into action and keep an eye on your site's performance as time goes on."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "At Molto SEO, we're committed to seeing you succeed in search engine optimisation. If you're interested in our SEO audit services and how they can enhance your website's visibility and ranking, we encourage you to get in touch with us right away."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    children: keywords.SEOAudit[5].title
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "In the ever-evolving digital landscape, staying ahead of the competition requires a thorough understanding of your website's technical performance, which might call for ",
                                                        keywords.SEOAudit[5].title,
                                                        ". That's where Molto SEO, the",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(links_NextLink/* default */.Z, {
                                                            title: keywords.GoogleAnalytics[3].title,
                                                            href: "/" + keywords.GoogleAnalytics[0].url + "/" + keywords.GoogleAnalytics[0].title.toLowerCase().replace(/ /g, "-")
                                                        }),
                                                        ", comes in. As a trusted provider of ",
                                                        keywords.SEOAudit[5].title,
                                                        ", we help businesses like yours identify and address potential issues that may be hindering your online visibility and organic rankings."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    children: keywords.SEOAudit[6].title
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "You might wonder, ",
                                                        keywords.SEOAudit[6].title,
                                                        "? An SEO audit serves as a roadmap to optimize your website and boost its visibility in search engine results pages (SERPs). It not only helps identify technical issues that may be hampering your rankings but also provides valuable insights into content optimization, backlink analysis, and overall website health. By conducting a thorough SEO audit, our team of ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(links_NextLink/* default */.Z, {
                                                            title: keywords.HomeList[6].title,
                                                            href: "/"
                                                        }),
                                                        " gives you a clear understanding of your website's strengths and weaknesses, enabling you to implement targeted strategies that enhance its performance and drive organic traffic. To truly decipher how you can optimize your website and boost your business is ",
                                                        keywords.SEOAudit[6].title,
                                                        "."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    children: keywords.SEOAudit[7].title
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "A ",
                                                        keywords.SEOAudit[7].title,
                                                        " is a comprehensive evaluation of your website's technical infrastructure, aiming to uncover any underlying issues that may impact its search engine performance. Our team of experts conducts a meticulous examination of various technical elements, including website speed, mobile-friendliness, site structure, URL structure, indexing, and crawlability, among others. By analyzing these factors, we identify areas for improvement and provide actionable recommendations to enhance your website's technical foundation. Molto SEO proposes various ways of conducting a",
                                                        " ",
                                                        keywords.SEOAudit[7].title,
                                                        " and offers a wide range of",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(links_NextLink/* default */.Z, {
                                                            title: keywords.EcommerceSEO[9].title,
                                                            href: "/" + keywords.EcommerceSEO[9].url + "/" + keywords.EcommerceSEO[9].title.toLowerCase().replace(/ /g, "-")
                                                        }),
                                                        "s, adapted to each customer."
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactFooterCombo/* default */.Z, {
                        location: "london"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var seo_audit_london = (seoAuditPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2634,1271,4525,4090,4870,4556,3835,5292,7024,9774,2888,179], function() { return __webpack_exec__(93209); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);